import React from 'react';
var esiComponents = {
  EsiChoose: function EsiChoose(data) {
    return "<esi:choose>".concat(renderComponents(data.placeholders['esi-choose']), "</esi:choose>");
  },
  EsiWhen: function EsiWhen(data) {
    return "<esi:when test=\"".concat(data.params.test, "\">").concat(renderComponents(data.placeholders['esi-when']), "</esi:when>");
  },
  EsiOtherwise: function EsiOtherwise(data) {
    return "<esi:otherwise>".concat(renderComponents(data.placeholders['esi-otherwise']), "</esi:otherwise>");
  },
  EsiForEach: function EsiForEach(data) {
    return "<esi:foreach item=\"".concat(data.params.item, "\" collection=\"").concat(data.params.collection, "\">").concat(renderComponents(data.placeholders['esi-for-each']), "</esi:foreach>");
  },
  EsiAssign: function EsiAssign(data) {
    return "<esi:assign name=\"".concat(data.params.name, "\" value=\"").concat(data.params.value, "\"></esi:assign>");
  }
};
function renderComponents(components) {
  return components.map(function (data) {
    var fn = esiComponents[data.componentName];
    return typeof fn === 'function' ? fn(data) : '';
  }).join('');
}
export default function EsiNoOutput(props) {
  var _a, _b;
  var placeholders = ((_a = props.rendering) === null || _a === void 0 ? void 0 : _a.placeholders) || {};
  var esidata = (_b = placeholders['esi-no-output']) !== null && _b !== void 0 ? _b : [];
  var esi = renderComponents(esidata);
  return React.createElement("script", {
    type: "text/esi",
    dangerouslySetInnerHTML: {
      __html: esi
    }
  });
}